if (!customElements.get('dio-header-logo-state')) {
  customElements.define(
    'dio-header-logo-state',
    class DioHeaderLogoState extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.header = this.closest('[data-dio-header-logo]');
        if (!this.header) return;

        this.threshold = Math.max(0, Number(this.dataset.scrollThreshold) || 0);
        this.onScroll = this.requestUpdate.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.frame) window.cancelAnimationFrame(this.frame);
        this.initialized = false;
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
        this.header.dataset.scrollState = scrollTop > this.threshold ? 'scrolled' : 'top';
      }
    }
  );
}
